<template>
  <div>
    <el-dialog
      v-if="dialog_release"
      class="dialog_big_box"
      :title="
        langSet == 'cn' ? '填写您的索样信息' : 'Fill in your sample information'
      "
      :visible.sync="dialog_release"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <div class="dialog_line"></div>
        <div class="dialog_box_top">
          <div class="dialog_title_picture">
            <img :src="userInfo.avatar" alt="" />
            <img
              v-if="userInfo.exhibitor_long_id"
              src="@/assets/authentication.png"
              alt=""
            />
          </div>
          <div style="color: #ffffff">
            <div class="dialog_title_name">
              <div>{{ userInfo.nickname }}</div>
              <div>{{ userInfo._duties }}</div>
              <div class="dialog_company">{{ userInfo.companyName }}</div>
            </div>
          </div>
          <img
            class="dialog_edit_img"
            src="@/assets/edit1.png"
            alt=""
            @click="toLink"
          />
        </div>
        <el-form
          :model="form"
          label-position="left"
          label-width="auto"
          style="max-width: 600px"
          :disabled="type == 'see'"
        >
          <div class="title_title">
            {{ langSet == "cn" ? "应答留言" : "Reply message" }}
          </div>
          <el-form-item
            :label="langSet == 'cn' ? '真实姓名' : 'Real Name'"
            prop="contact_name"
          >
            <el-input
              v-model="form.contact_name"
              type="text"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '手机号' : 'Phone Number'"
            prop="contact_mobile"
          >
            <el-input
              v-model="form.contact_mobile"
              type="text"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '详细地址' : 'Detailed Address'"
            prop="address"
          >
            <el-input
              v-model="form.address"
              type="text"
              placeholder=""
            ></el-input>
          </el-form-item>
          <div class="title_title">
            {{
              langSet == "cn"
                ? "填写需求【产品应用于（多选 最多三个）】"
                : "Fill in the requirement [Product Application (Multiple Choice Up to Three)]"
            }}
          </div>
          <el-form-item label="" prop="name">
            <div class="tag_box">
              <div
                :class="['tag_item', item.selected ? 'selected' : '']"
                v-for="(item, index) in NeedLabel"
                :key="index"
                @click="tag_item_click(index, item)"
              >
                {{ item.labelName }}
              </div>
            </div>
          </el-form-item>
          <div class="title_title">
            {{ langSet == "cn" ? "需求描述" : "Requirement" }}
          </div>
          <el-form-item label="" prop="content">
            <el-input
              type="textarea"
              :rows="7"
              resize="none"
              :placeholder="
                langSet == 'cn'
                  ? '请详细描述您的需求'
                  : 'Please provide a detailed description of your requirements'
              "
              v-model="form.content"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span class="dialog-footer">
        <el-button
          class="dialog_submit"
          type="primary"
          v-prevent-re-click
          v-if="type != 'see'"
          @click="submit"
          >{{ langSet == "cn" ? "提 交" : "Submit" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { getNeedLabel } from "@/api/business_api";
import { MemberConsultation_add } from "@/api/product_api";
import { sdkClick } from "../../../sdk/useSdk";
export default {
  name: "",
  props: ["dialog_release", "details", "label_value", "type", "form_details"],
  data() {
    return {
      langSet: "",
      form: {
        contact_name: "", //真实姓名
        contact_mobile: "", //手机号
        address: "", //地址
        content: "", //需求描述
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      NeedLabel: [], //需求标签
    };
  },
  mounted() {
    this.langSet = this.$language;
    this.getNeedLabel();
  },
  methods: {
    // 获取需求标签
    async getNeedLabel() {
      const res = await getNeedLabel();
      this.NeedLabel = res.data.lists;
      this.NeedLabel.forEach((item) => {
        item.selected = false;
      });
      if (this.form_details) {
        this.form = this.form_details;
        let list = this.form.usearea_label_ids.split(",");
        list.forEach((item) => {
          this.NeedLabel.forEach((items) => {
            if (item == items.id) {
              items.selected = true;
            }
          });
        });
      }
    },
    tag_item_click(index, items) {
      const list = this.NeedLabel.filter((item) => item.selected);
      const lists = list.filter((item) => item.id == items.id);
      if (list.length > 0) {
        if (lists.length > 0) {
          this.NeedLabel[index].selected = !this.NeedLabel[index].selected;
        } else {
          if (list.length >= 3) {
            return this.$message.warning("最多选择三项");
          } else {
            this.NeedLabel[index].selected = !this.NeedLabel[index].selected;
          }
        }
      } else {
        this.NeedLabel[index].selected = !this.NeedLabel[index].selected;
      }
      this.NeedLabel = [...this.NeedLabel];
    },
    async submit() {
      let label_idstr = [];
      let label_idstr_name = [];
      this.NeedLabel.forEach((item, index) => {
        if (item.selected) {
          label_idstr.push(item.id);
          label_idstr_name.push(item.labelName);
        }
      });
      let data = {
        companyid: this.details.companyid, //被索样展商id
        productid: this.details.id, //索样产品id
        content: this.form.content, //索样内容
        contact_name: this.form.contact_name, //真实姓名
        contact_mobile: this.form.contact_mobile, //手机号
        address: this.form.address, //地址
        usearea_label: label_idstr_name.join(","), //需求标签
        usearea_label_ids: label_idstr.join(","), //需求标签id
      };
      sdkClick(
        "产品索样",
        this.details.exhibitor.companyName + ">>" + this.details.goodsName
      );
      const res = await MemberConsultation_add(data);
      this.$message.success(res.msg);
      this.handleClose();
    },
    handleClose() {
      this.$emit("add_request", true);
    },
    toLink() {
      this.$router.push({
        path: "/personal",
      });
    },
  },
};
</script>


<style scoped lang="scss">
/deep/ .el-select {
  width: 100% !important;
}

/deep/ .el-date-editor {
  width: 100% !important;
}

//弹窗
.dialog_big_box {
  /deep/ .el-dialog {
    width: 525px !important;
    height: 650px !important;
    overflow-y: auto;
    background: #ffffff;
    border-radius: 20px;
    position: relative;
  }

  .title_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin: 10px 0;
  }

  .dialog-footer {
    //position: absolute;
    display: flex;
    justify-content: center;
    //margin: 30px;
  }

  /deep/ .el-dialog__body {
    padding: 0 30px 30px 30px !important;
  }

  .dialog_line {
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
  }

  .dialog_box_top {
    position: relative;
    display: flex;
    padding: 10px;
    align-items: center;
    height: 110px;
    background: #f7f8fa;
    border-radius: 8px;
    margin: 20px 0 15px 0;
  }

  .dialog_title_picture {
    position: relative;
    margin-right: 10px;
  }

  .dialog_title_picture > img:first-child {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .dialog_title_picture > img:nth-child(2) {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .dialog_title_name {
    //display: flex;
    margin-bottom: 5px;
    align-items: center;
    margin-left: 10px;
  }

  .dialog_title_name > div:nth-child(1) {
    margin-bottom: 3px;
    font-weight: 500;
    font-size: 20px;
    color: #001a33;
    line-height: 30px;
    letter-spacing: 1px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_title_name > div:nth-child(2) {
    margin-bottom: 3px;
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_company {
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: left;
    font-style: normal;
  }

  .dialog_edit_img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 18px;
    right: 18px;
    cursor: pointer;
  }

  .tag_box {
    display: flex;
    flex-wrap: wrap;
  }

  .tag_item {
    //overflow: hidden;
    //white-space: nowrap;
    //text-overflow: ellipsis;
    cursor: pointer;
    box-sizing: border-box;
    //width: calc((100% - 30px) / 3);
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #cad2dd;
    margin: 0 15px 15px 0;
    color: #888888;
    //&:nth-child(3n) {
    //  margin-right: 0;
    //}
  }

  .selected {
    background: #1d2379;
    color: #ffffff;
  }

  .dialog_footer {
  }

  .dialog_submit {
    width: 180px;
    height: 42px;
    border-radius: 9px;
    background-color: #004190;
    border-color: #004190;
  }

  .dialog_submit:hover {
    background-color: #004190;
    opacity: 0.9;
  }

  .dialog_submit:focus {
    background-color: #004190;
    opacity: 1;
  }

  /deep/ .el-form-item__label {
    line-height: 14px;
  }

  /* 隐藏上传按钮 */
  .hide-upload ::v-deep .el-upload--picture-card {
    display: none;
  }

  /deep/ .el-upload-list__item {
    width: 97px;
    height: 97px;
  }

  /deep/ .el-upload--picture-card {
    width: 97px;
    height: 97px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /deep/ .el-form-item__label-wrap {
    line-height: 38px;
  }

  //.image_list{
  //  display: flex;
  //  align-items: center;
  //
  //  .item_image{
  //    width: 97px;
  //    height: 97px;
  //  }
  //  .el-image{
  //    width: 97px;
  //    height: 97px;
  //    position: relative;
  //    .upload-span{
  //      position: absolute;
  //      z-index: 99;
  //      top: 0;
  //      left: 0;
  //    }
  //  }
  //
  //}
}

@media only screen and (max-width: 767px) {
  .dialog_big_box {
    /deep/ .el-dialog {
      width: 6.54rem !important;
      height: auto !important;
      background: #ffffff;
      border-radius: 0.38rem;
    }

    /deep/ .el-dialog__body {
      padding: 0 0.29rem 0.29rem 0.29rem !important;
    }
  }
}
</style>